const actionTypes = require('constants/actionTypes');
const { APIGet } = require('utilities/APIRequestHelper');

const getCardsCanceledRequest = () => ({
    type: actionTypes.CARDS_CANCELED_REQUEST
});

const getCardsCanceledFailure = error => ({
    type: actionTypes.CARDS_CANCELED_FAILURE,
    payload: {
        error
    }
});

const getCardsCanceledSuccess = cardsCanceled => ({
    type: actionTypes.CARDS_CANCELED_SUCCESS,
    payload: {
        cardsCanceled
    }
});

const setHolderCanceledCard = (holder, cardId) => ({
    type: actionTypes.CARDS_CANCELED_SET_HOLDER_SUCCESS,
    payload: {
        cardId,
        holder
    }
});

const getCardsCanceled = () => (dispatch) => {
    const requestData = {
        query: {
            cardStatusType: 'BLOQUEADO_CANCELADO'
        }
    };
    dispatch(getCardsCanceledRequest());
    return APIGet({
        dispatch,
        endpoint: 'cardsContracts',
        params: requestData
    })
        .then(response => {
            dispatch(getCardsCanceledSuccess(response.response));
        })
        .catch(response => {
            if(!!response.error) {
                dispatch(getCardsCanceledFailure(response.error));
            } else {
                throw response;
            }
        });
};

module.exports = {
    getCardsCanceled,
    setHolderCanceledCard
}
